module.exports = __webpack_public_path__ + "img/dsci0003.cfe19110.jpg";